import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/ApiService'

class WorkLocations extends Component {
    constructor() {
        super()
        this.state = {
            worklocationList: {},
            city_id:"",
            type:""
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getWorkLocationsList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

     componentDidUpdate() {

        if (this.props.city_id!== this.state.city_id || this.props.type!== this.state.type) {
             let city_id=this.props.city_id 
             let type=this.props.type 
             this.setState({
                city_id:city_id,
                type:type,
                },() => {
                 this.getWorkLocationsList()
            });            
        }
    }

    getWorkLocationsList = () => {
        apiService.getWorkLocationsDetailList(this.state.city_id,this.state.type)
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        worklocationList: listData.data
                    })                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.worklocationList).map((value,index) => {
            
            return {
                label : this.state.worklocationList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Work Location"
                options={list}
                onChange={(e) => { (e) ? this.props.workLocationChange(e) : this.props.workLocationChange([])}}
                />
            </div>
        )
    }
}
export default WorkLocations


// WEBPACK FOOTER //
// ./src/common/DropDowns/WorkLocations.js